import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { elmoExperimentResourceNames } from '../../lib/experiments-helper';
import { getElmoExperiments } from './action-app';

function requestOpenCaseChecker() {
  return { type: types.REQUEST_OPEN_CASE };
}

function receiveOpenCaseCheckerError() {
  return { type: types.RECEIVE_OPEN_CASE_ERROR };
}

function receiveOpenCase(payload) {
  return { type: types.RECEIVE_OPEN_CASE, payload };
}

export default function getOpenCase() {
  return (dispatch) => {
    dispatch(requestOpenCaseChecker());
    return axios.get('/smarthelp/user-cases')
    .then((response) => {
      // dispatching ELMO when disputes exists in response
      if (response.data && Array.isArray(response.data.cases) && response.data.cases.length) {
        dispatch(getElmoExperiments(elmoExperimentResourceNames.pendingDisputes));
      }
      dispatch(receiveOpenCase(response.data && response.data.cases));
    })
    .catch(() => { dispatch(receiveOpenCaseCheckerError()); });
  };
}
